import * as React from "react";
const SvgFiRrSquare2 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-square-2_svg__a)">
      <path
        fill="#062147"
        d="M19 24H5c-2.757 0-5-2.243-5-5V5c0-2.757 2.243-5 5-5h14c2.757 0 5 2.243 5 5v14c0 2.757-2.243 5-5 5M5 2C3.346 2 2 3.346 2 5v14c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3V5c0-1.654-1.346-3-3-3zm11 15a1 1 0 0 0-1-1h-4.781c.426-.37 1.069-.72 1.742-1.086 1.753-.956 4.156-2.264 4.035-5.131C15.906 7.662 14.151 6 12.001 6c-2.206 0-4 1.794-4 4a1 1 0 0 0 2 0c0-1.103.897-2 2-2 1.058 0 1.953.838 1.997 1.868.063 1.512-1.088 2.252-2.994 3.29-.99.539-1.925 1.048-2.559 1.797a1.84 1.84 0 0 0-.272 1.983A1.82 1.82 0 0 0 9.839 18h5.162A1 1 0 0 0 16 17"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-square-2_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSquare2;
